import {TrekModel} from '@/Pages/Admin/Modules/Models/TrekModel';
import {SeasonModel} from '@/Pages/Admin/Modules/Models/Master/SeasonModel';

export class TrekDepartureModel {
    public id: number;
    public trek_id: number;
    public start_date: string;
    public end_date: string;
    public start_time: string;
    public end_time: string;
    public has_departure_pricing_rule: number;
    public has_departure_price: number;
    public price: string;
    public min_quota: number;
    public max_quota: number;
    public available_seats: number;
    public booked_seats: number;
    public season_id: number;
    public status: number;
    public created_at: string;
    public updated_at: string;
    public bookings_count: number;
    public pre_bookings_count: number;
    public departure_time: string;
    public trek: TrekModel = new TrekModel({});
    public season: SeasonModel = new SeasonModel({});

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.trek_id = obj.trek_id ? obj.trek_id : 0;
        this.start_date = obj.start_date ? obj.start_date : '';
        this.end_date = obj.end_date ? obj.end_date : '';
        this.start_time = obj.start_time ? obj.start_time : '';
        this.end_time = obj.end_time ? obj.end_time : '';
        this.has_departure_pricing_rule = obj.has_departure_pricing_rule ? obj.has_departure_pricing_rule : 0;
        this.has_departure_price = obj.has_departure_price ? obj.has_departure_price : 0;
        this.price = obj.price ? obj.price : '';
        this.min_quota = obj.min_quota ? obj.min_quota : 0;
        this.max_quota = obj.max_quota ? obj.max_quota : 0;
        this.available_seats = obj.available_seats ? obj.available_seats : 0;
        this.booked_seats = obj.booked_seats ? obj.booked_seats : 0;
        this.season_id = obj.season_id ? obj.season_id : 0;
        this.status = obj.status ? obj.status : 0;
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
        this.bookings_count = obj.bookings_count ? obj.bookings_count : 0;
        this.pre_bookings_count = obj.pre_bookings_count ? obj.pre_bookings_count : 0;
        this.departure_time = obj.departure_time ? obj.departure_time : '';
        this.trek = obj.trek ? obj.trek : new TrekModel({});
        this.season = obj.season ? obj.season : new SeasonModel({});
    }
}
